// Catalog of texture thumbnails. Place PNG files under client/public/textures/
// and reference them here by filename (without extension if consistent).
// Each entry: { id, name, file }
export const TEXTURES = [
  { id: '3px-tile', name: '3px Tile', file: '3px-tile.png' },
  { id: 'asfalt-light', name: 'Asfalt Light', file: 'asfalt-light.png' },
  { id: 'basketball', name: 'Basketball', file: 'basketball.png' },
  { id: 'black-orchid', name: 'Black Orchid', file: 'black-orchid.png' },
  { id: 'black-twill', name: 'Black Twill', file: 'black-twill.png' },
  { id: 'cartographer', name: 'Cartographer', file: 'cartographer.png' },
  { id: 'checkered-pattern', name: 'Checkered', file: 'checkered-pattern.png' },
  { id: 'classy-fabric', name: 'Classy Fabric', file: 'classy-fabric.png' },
  { id: 'clean-gray-paper', name: 'Clean Paper', file: 'clean-gray-paper.png' },
  { id: 'crissxcross', name: 'Crissxcross', file: 'crissxcross.png' },
  { id: 'dark-circles', name: 'Dark Circles', file: 'dark-circles.png' },
  { id: 'dark-denim-3', name: 'Dark Denim', file: 'dark-denim-3.png' },
  { id: 'dark-dotted-2', name: 'Dark Dotted', file: 'dark-dotted-2.png' },
  { id: 'dark-leather', name: 'Dark Leather', file: 'dark-leather.png' },
  { id: 'dark-mosaic', name: 'Dark Mosaic', file: 'dark-mosaic.png' },
  { id: 'dark-stripes', name: 'Dark Stripes', file: 'dark-stripes.png' },
  { id: 'food', name: 'Food', file: 'food.png' },
  { id: 'gplay', name: 'GPlay', file: 'gplay.png' },
  { id: 'gradient-squares', name: 'Gradient Squares', file: 'gradient-squares.png' },
  { id: 'gravel', name: 'Gravel', file: 'gravel.png' },
  { id: 'grid-me', name: 'Grid', file: 'grid-me.png' },
  { id: 'grid-noise', name: 'Grid Noise', file: 'grid-noise.png' },
  { id: 'groovepaper', name: 'Groovepaper', file: 'groovepaper.png' },
  { id: 'hexellence', name: 'Hexellence', file: 'hexellence.png' },
  { id: 'hixs-evolution', name: "HiXS Evolution", file: 'hixs-evolution.png' },
  { id: 'hoffman', name: 'Hoffman', file: 'hoffman.png' },
  { id: 'honey-im-subtle', name: "Honey I'm Subtle", file: 'honey-im-subtle.png' },
  { id: 'ice-age', name: 'Ice Age', file: 'ice-age.png' },
  { id: 'inflicted', name: 'Inflicted', file: 'inflicted.png' },
  { id: 'inspiration-geometry', name: 'Inspiration Geometry', file: 'inspiration-geometry.png' },
  { id: 'light-honeycomb-dark', name: 'Honeycomb Dark', file: 'light-honeycomb-dark.png' },
  { id: 'light-wool', name: 'Light Wool', file: 'light-wool.png' },
  { id: 'low-contrast-linen', name: 'Linen', file: 'low-contrast-linen.png' },
  { id: 'maze-black', name: 'Maze Black', file: 'maze-black.png' },
  { id: 'nami', name: 'Nami', file: 'nami.png' },
  { id: 'nasty-fabric', name: 'Nasty Fabric', file: 'nasty-fabric.png' },
];

export const textureUrl = (file) => `/textures/${file}`;
